export { default as api } from "./repository/apiRepository"
export { default as apiLeagueServer } from "./repository/apiLeague"
